module.exports = __webpack_public_path__ + "img/theme_dark.ce030f.svg";